import { size } from 'app/components/foundation';

export const style = {
  searchBoxField: {
    width: size.INPUT_SIZE.SMALL,
  },
};
